const config = {
	yupLocale: {
		mixed: { required: 'Required field' },
	},
}

export default config
